import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-133f5daa")

_pushScopeId("data-v-133f5daa")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h4", null, "Endereço de Entrega", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createVNode("h4", null, "Forma de Pagamento", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "value-delivery" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, "Taxa de entrega", -1)
const _hoisted_9 = { class: "value-total" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", null, "Total do pedido", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Confirmar Pedido")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_content = _resolveComponent("ion-content")

  return (_openBlock(), _createBlock(_component_ion_content, { onClick: _ctx.closeModal }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_ion_card, { class: "card-body" }, {
          default: _withId(() => [
            _createVNode(_component_ion_card_content, null, {
              default: _withId(() => [
                _createVNode(_component_ion_card, { class: "address" }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_card_content, null, {
                      default: _withId(() => [
                        _hoisted_2,
                        (_ctx.address && !_ctx.data.isWithdraw)
                          ? (_openBlock(), _createBlock("div", _hoisted_3, [
                              _createVNode("p", null, _toDisplayString(_ctx.address.streetName) + _toDisplayString(_ctx.address.addressNumber ? ", " + _ctx.address.addressNumber : ""), 1),
                              _createVNode("p", null, _toDisplayString(_ctx.address.complement) + " " + _toDisplayString(_ctx.address.reference ? "- " + _ctx.address.reference : ""), 1)
                            ]))
                          : (_openBlock(), _createBlock("p", _hoisted_4, "Você irá retirar no estabelecimento!"))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card, { class: "payment" }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_card_content, null, {
                      default: _withId(() => [
                        _hoisted_5,
                        _createVNode("p", null, _toDisplayString(_ctx.infoPaymentMethod(_ctx.payment)), 1),
                        _createVNode("span", null, _toDisplayString(_ctx.payment.paymentMethod
                  ? "Pagamento na Entrega"
                  : "Pagamento Online"), 1),
                        (_ctx.payment.change)
                          ? (_openBlock(), _createBlock("span", _hoisted_6, " Troco para " + _toDisplayString(_ctx.moneyMask(_ctx.payment.change)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_card_content, null, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createVNode("span", null, _toDisplayString(_ctx.deliveryFee), 1)
                        ]),
                        _createVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _createVNode("span", null, _toDisplayString(_ctx.total), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  shape: "round",
                  expand: "full",
                  onClick: _ctx.confirmOrder
                }, {
                  default: _withId(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["onClick"]))
})